import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type {
  EnergyRevenuesCellCheckState,
  EnergyRevenuesCellCheckStateResponse
} from "../RevenueMonitoring.types";

export function useEnergyRevenuesVerificationMutations(personId?: number) {
  const queryClient = useQueryClient();

  const createVerificationMutation = useMutation({
    mutationFn: (verificationItem: EnergyRevenuesCellCheckState) =>
      createEnergyRevenuesVerification(verificationItem),
    onSuccess: invalidateQueries
  });

  const updateVerificationMutation = useMutation({
    mutationFn: ({
      verificationItem,
      verificationId
    }: {
      verificationItem: EnergyRevenuesCellCheckState;
      verificationId: string;
    }) => updateEnergyRevenuesVerification(verificationItem, verificationId),
    onSuccess: invalidateQueries
  });

  const deleteVerificationMutation = useMutation({
    mutationFn: (verificationId: string) =>
      deleteEnergyRevenuesVerification(verificationId),
    onSuccess: invalidateQueries
  });

  function invalidateQueries() {
    queryClient.invalidateQueries({
      queryKey: ["energyRevenuesVerificationItems", { personId }]
    });
  }

  return {
    createVerificationMutation,
    updateVerificationMutation,
    deleteVerificationMutation
  };
}

function createEnergyRevenuesVerification(
  verificationItem: EnergyRevenuesCellCheckState
) {
  const url = urls.apiWithoutCamelization.revenueMonitoringCellChecks();
  return apiWithoutCamelization.post<EnergyRevenuesCellCheckStateResponse>(
    url,
    verificationItem
  );
}

function updateEnergyRevenuesVerification(
  verificationItem: EnergyRevenuesCellCheckState,
  verificationId: string
) {
  const url =
    urls.apiWithoutCamelization.revenueMonitoringCellCheck(verificationId);
  return apiWithoutCamelization.patch<EnergyRevenuesCellCheckStateResponse>(
    url,
    verificationItem
  );
}

function deleteEnergyRevenuesVerification(verificationId: string) {
  const url =
    urls.apiWithoutCamelization.revenueMonitoringCellCheck(verificationId);
  return apiWithoutCamelization.delete(url);
}
